export default "__VITE_ASSET__Cso5Kuxc__"